<template>
  <div class="game-row-item">
    <el-select
      class="multiple-selector"
      placeholder="请选择中间件游戏"
      v-model="gameItem.middleGameIds"
      multiple
      collapse-tags
      filterable
      clearable
      style="min-width: 220px"
      @change="onChange"
    >
      <el-option v-for="item in parentForm.middlewareGameData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
    </el-select>

    <slot>
      <el-select v-model="gameItem.platforms" placeholder="请选择平台" style="min-width: 255px" multiple @change="onChange">
        <el-option v-for="item in DailyReports.GAME_PLATFORM_LIST" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
    </slot>
  </div>
</template>
<script>
import DailyReports from '../data/daily.class.js'

export default {
  props: ['gameItem'],
  inject: ['parentForm'],
  computed: {
    DailyReports() {
      return DailyReports
    }
  },
  methods: {
    onChange() {
      this.$emit('change')
    }
  }
}
</script>
<style lang="scss" scoped>
@import './styles/game-row.scss';
</style>
